<template class="ml-3">
	<div v-if="loading == false" class="mx-3">
		<div>
			<v-subheader :class="theme.dark && 'col-white'">Study</v-subheader>
			<template>
				<template>
					<v-chip-group
						multiple
						active-class="chip-active"
						class="ml-3"
						v-model="selected_course_subjects"
					>
						<v-chip filter v-for="subject in subjects" :key="subject">
							{{ subject }}
						</v-chip>
					</v-chip-group>
				</template>
				<div
					v-if="filtered_courses.length == 0"
					class="text-subtitle-1 ml-4"
					:class="theme.dark && 'col-white'"
				>
					There are no courses no show
				</div>
				<div class="content-holder" v-if="filtered_courses.length > 0">
					<v-hover
						class="content-wrapper mx-4 my-5"
						v-for="course in filtered_courses"
						:key="course.id"
					>
						<template v-slot="{ hover }">
							<div
								:class="`elevation-${hover ? 14 : 1}`"
								class="transition-swing rounded-lg"
							>
								<v-card
									@click="goToCourse(course.id)"
									class="body-card rounded-lg"
									max-width="300"
									color="white"
									ripple
								>
									<div class="content-card">
										<div
											class="subject-box"
											:style="{
												'background-image': `url('${course.subject.image}') !important`,
											}"
										>
											<span
												v-if="course.has_completed"
												class="float-right mr-3 font-tiny mt-5 absolute-right"
											>
												<v-chip
													class="ml-5"
													:style="{
														'background-color': `${theme.success_light} !important`,
														color: `${theme.success} !important`,
													}"
												>
													<span
														class="mr-2 font-tiny"
														:style="{
															color: `${theme.success} !important`,
														}"
													>
														Done
													</span>
													<v-icon id="icon" size="12">mdi-check</v-icon>
												</v-chip>
											</span>
											<div class="text-center card-title">
												{{ course.subject.name }}
											</div>
										</div>
										<v-card-title
											class="card-title text-truncate course-name"
											:class="course.name.length > 32 && 'custom-truncate'"
											>{{ course.name }}</v-card-title
										>

										<v-card-subtitle class="pb-0 font-small">{{
											`Grade ${course.grade} • Level ${course.difficulty}`
										}}</v-card-subtitle>

										<v-card-text class="text--primary pb-10 pt-2">
											<div
												class="card-title float-left font-small text-truncate course-name max-200"
												:class="
													course.school.name.length > 10 && 'custom-truncate'
												"
											>
												{{ course.school.name }}
											</div>

											<div class="float-right font-small">
												{{ formatDuration(course.duration) }}
											</div>
										</v-card-text>
									</div>
								</v-card>
							</div>
						</template>
					</v-hover>
				</div>
			</template>
		</div>

		<div v-if="quizzes">
			<v-subheader :class="theme.dark && 'col-white'">Take a Quiz</v-subheader>
			<template>
				<template>
					<v-chip-group
						multiple
						active-class="chip-active"
						class="ml-3"
						v-model="selected_quiz_subjects"
					>
						<v-chip filter v-for="subject in subjects" :key="subject">
							{{ subject }}
						</v-chip>
					</v-chip-group>
				</template>
				<div
					v-if="filtered_quizzes.length == 0"
					class="text-subtitle-1 ml-4"
					:class="theme.dark && 'col-white'"
				>
					There are no quizzes no show
				</div>
				<div class="content-holder" v-if="filtered_quizzes.length > 0">
					<v-hover
						class="content-wrapper mx-4 my-5"
						v-for="quiz in filtered_quizzes"
						:key="quiz.id"
					>
						<template v-slot="{ hover }">
							<div
								:class="`elevation-${hover ? 14 : 1}`"
								class="transition-swing rounded-lg"
							>
								<v-card
									@click="goToQuiz(quiz.id)"
									class="body-card rounded-lg"
									max-width="300"
									color="white"
									ripple
								>
									<div class="content-card">
										<div
											class="subject-box"
											:style="{
												'background-image': `url('${quiz.subject.image}') !important`,
											}"
										>
											<span
												v-if="quiz.has_completed"
												class="float-right mr-3 font-tiny mt-5 absolute-right"
											>
												<v-chip
													class="ml-5"
													:style="{
														'background-color': `${theme.success_light} !important`,
														color: `${theme.success} !important`,
													}"
												>
													<span
														class="mr-2 font-tiny"
														:style="{
															color: `${theme.success} !important`,
														}"
													>
														{{ quiz.previous_attempt.score }}
													</span>
													<v-icon id="icon" size="12">mdi-check</v-icon>
												</v-chip>
											</span>
											<div class="text-center card-title">
												{{ quiz.subject.name }}
											</div>
										</div>
										<v-card-title class="card-title">{{
											quiz.name
										}}</v-card-title>

										<v-card-subtitle class="pb-0 font-small">{{
											`Grade ${quiz.grade} • Level ${quiz.difficulty}`
										}}</v-card-subtitle>

										<v-card-text class="text--primary pb-10 pt-2">
											<div
												class="card-title float-left font-small text-truncate course-name max-200"
												:class="
													quiz.school.name.length > 10 && 'custom-truncate'
												"
											>
												{{ quiz.school.name }}
											</div>

											<div class="float-right font-small">
												{{ formatDuration(quiz.duration) }}
											</div>
										</v-card-text>
									</div>
								</v-card>
							</div>
						</template>
					</v-hover>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'Dashboard',

	data: () => ({
		courses: [],
		quizzes: [],
		subjects: [],
		selected_course_subjects: [],
		selected_quiz_subjects: [],
	}),

	mounted() {
		if (this.user == null) this.$router.push({ name: 'Login' })

		this.forceLoad()
		this.core.http
			.get('courses')
			.then(response => {
				this.courses = response.data.courses
			})
			.catch(error => {
				this.setAlert(error.response)
			})

		this.core.http
			.get('quizzes')
			.then(response => {
				this.quizzes = response.data.quizzes
			})
			.catch(error => {
				this.setAlert(error.response)
			})

		this.core.http
			.get('subjects')
			.then(response => {
				this.subjects = response.data.subjects
			})
			.catch(error => {
				this.setAlert(error.response)
			})
	},
	methods: {
		...mapMutations(['setAlert', 'forceLoad']),
		formatDuration(duration) {
			let format = 'HH[h] mm[m]'
			if (duration < 60) format = 'mm[m]'

			return this.core.moment
				.utc(this.core.moment.duration(duration, 'minutes').asMilliseconds())
				.format(format)
		},
		goToCourse(course_id) {
			this.$router.push({ name: 'Course', params: { id: course_id } })
		},
		goToQuiz(quiz_id) {
			this.$router.push({ name: 'Quiz', params: { id: quiz_id } })
		},
	},
	computed: {
		...mapGetters(['loading', 'theme', 'user']),

		filtered_courses: function() {
			if (this.selected_course_subjects.length == 0) return this.courses
			const subjects = this.selected_course_subjects.map(s => this.subjects[s])
			return this.courses.filter(c => subjects.includes(c.subject.name))
		},

		filtered_quizzes: function() {
			if (this.selected_quiz_subjects.length == 0) return this.quizzes
			const subjects = this.selected_quiz_subjects.map(s => this.subjects[s])
			return this.quizzes.filter(q => subjects.includes(q.subject.name))
		},

		contents_present: function() {
			return (
				this.filtered_courses.length > 0 && this.filtered_quizzes.length > 0
			)
		},
	},

	watch: {
		contents_present(new_val) {
			if (new_val == true) this.forceLoad(false)
		},
	},

	beforeDestroy: function() {
		this.forceLoad(false)
	},
}
</script>

<style scoped>
.content-wrapper {
	display: inline-block;
	width: 300px;
}
.subject-box {
	height: 120px;
	background-color: white;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	background-size: cover;
}
.subject-box div {
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	color: white;
	padding-top: 45px;
	font-size: 1.5rem;
	color: white;
	background-color: rgba(0, 0, 0, 0.6);
	height: 100%;
}
.body-card:hover {
	cursor: pointer;
}
.content-holder {
	height: 320px;
	overflow-x: scroll;
	overflow-y: hidden;
	white-space: nowrap;
	-webkit-overflow-scrolling: touch;
}
/* ::-webkit-scrollbar {
	width: 0px;
	background: transparent;
} */
.card-title {
	font-size: 0.9rem !important;
}
.chip-active {
	color: #1d1641 !important;
	background-color: #e8e5f6 !important;
}
.course-name {
	width: 270px;
}
.custom-truncate::after {
	content: ' ...';
	position: absolute;
	right: 0;
	margin-right: 15px;
}
.absolute-right {
	position: absolute;
	right: 0;
}
.max-200 {
	max-width: 200px !important;
}
</style>
